import { useContext, useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { DispatchContext, StateContext } from '../../App';
import { openDialogWindow } from '../../functions/functions';
import LangList from './LangList';

import './Header.css';
import logo from '../../images/icons/logo.svg';

const Header = () => {
    const appState = useContext(StateContext);
    const dispatch = useContext(DispatchContext);

    const { language, isArticleSelected } = appState.appSettings;

    const [ activeLang, setActiveLang ] = useState(language);
    const [ isMouseOver, setIsMouseOver ] = useState(false);

    const toggleIsMouseOver = () => {
        setIsMouseOver(false);
    };

    useEffect(() => {
        setActiveLang(language)
    }, [language])

    return (
        <div className='app-header bottom-shadow'>
            <div className='grow'>
                <a className='rodalink' href='https://www.rodaonline.com/' target='_blank' rel="noreferrer"><img className='logo-roda' src={logo} alt='logo roda'/></a>
            </div>
            {
                isArticleSelected ? <button 
                    className='header-btn'
                    onClick={() => {openDialogWindow(dispatch)}}
                >
                    <FormattedMessage 
                        id='new_configuration'
                        defaultMessage='New configuration'
                    />
                </button> : null
            }
            
            <button className='header-btn'>
                Login
            </button>
            <button 
                className='lang-btn'
                onMouseOver={() => setIsMouseOver(true)}
            >
                { activeLang.toUpperCase() }
            </button>
            {
                isMouseOver ? <LangList 
                    isMouseOver={isMouseOver}
                    toggleIsMouseOver={toggleIsMouseOver}
                /> : null
            }
        </div>
    )
};
export default Header;
